import * as React from "react";

import { ArrowBack } from "@livechat/design-system-icons";
import { Button, Heading, Icon, IconSource, SpacingToken } from "@livechat/design-system-react-components";

import { IViewContainerProps, ViewContainer } from "components/grid";
import Flex from "components/layout/Flex";
import { isInIframe } from "helpers/app";
import { withVar } from "themes/helpers";

interface IProps extends IViewContainerProps {
  onBack(): void;
  backButtonIcon?: IconSource;
}

const FullPageViewContainer: React.FC<IProps> = ({ children, title, onBack, backButtonIcon, ...props }) => {
  const isEmbeddedInIframe = isInIframe();

  const backButton = (
    <Flex alignItems="center" marginLeft={withVar(SpacingToken.Spacing3)} gap={withVar(SpacingToken.Spacing2)}>
      <Button
        kind="plain"
        size="compact"
        onClick={onBack}
        icon={<Icon source={backButtonIcon || ArrowBack} />}
        data-testid="back-button"
      />
      <Heading size={isEmbeddedInIframe ? "xs" : undefined}>{title}</Heading>
    </Flex>
  );

  return (
    <ViewContainer {...props} stackShowBackButton backButton={backButton} placement="main-content">
      {children}
    </ViewContainer>
  );
};

export default FullPageViewContainer;
